/**
 * @flow
 * @relayHash 815f11aeb496dbf47bb4079c44deafa5
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type initializeTrackingQueryResponse = {|
  +viewer: ?{|
    +submittedTransactions?: ?{|
      +totalResults: ?number;
    |};
    +confirmedTransactionsMostRecent?: ?{|
      +totalResults: ?number;
    |};
    +user?: ?{|
      +createdDate: ?string;
      +firstSessionDate: ?string;
      +isTrade: ?boolean;
      +hasVipPermission: ?boolean;
      +profile: ?{|
        +email: ?string;
        +zipCode: ?string;
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
      +serviceId: ?string;
      +totalMessagesToDealers: ?number;
      +tradeFirm: ?{|
        +serviceId: ?string;
        +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
      |};
      +verifiedTradeStatus: ?string;
    |};
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String!]",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "initializeTrackingQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactionsMostRecent",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.confirmed",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "createdDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstSessionDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "isTrade",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_TRADE_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "hasVipPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "zipCode",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "currency",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalMessagesToDealers",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "tier",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "verifiedTradeStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": "dibs-buyer-layout/197.2.7-2018-12-18T14:46:37.217Z/initializeTrackingQuery",
  "kind": "Batch",
  "metadata": {},
  "name": "initializeTrackingQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String!]",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "initializeTrackingQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactionsMostRecent",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.confirmed",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "createdDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstSessionDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "isTrade",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_TRADE_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "hasVipPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "zipCode",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "currency",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalMessagesToDealers",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "tier",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "verifiedTradeStatus",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
